import React, { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { updateTransactions } from "../../firebase/firebase";
import toast from "react-hot-toast";
import PersonalTransactions from "../transactionItems/personalTransactions";
import "../../css/homepage.css";

const Payment = ({ values }) => {
  // get personal transactions
  const [transactions, setTransactions] = useState([]);

  // set friend
  const [friend, setFriend] = useState({
    address: "",
    amount: 0,
  });

  // setID
  // const [id, setId] = useState()
  const navigate = useNavigate();

  // proceed to payment details
  const handleProceed = (id, item) => {
    id &&
      navigate(generatePath("/dashboard/payment/:id", { id }), {
        state: item,
      });
  };

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFriend({
      ...friend,
      [name]: value,
    });
  };

  useEffect(() => {
    setTransactions(values?.transactions);
  }, []);

  // send transactions to loved ones
  const sendTokens = async () => {
    try {
      const notification = toast.loading(
        `⏳ Sending ${friend.amount}TRX to ${friend.address}`
      );
      const tronweb = window.tronWeb;
      const amt = await tronweb.toSun(friend.amount);
      const sendF = await tronweb.trx.sendTransaction(friend.address, amt);
      
      // get gas price

      let hash = sendF?.transaction.txID;
      await updateTransactions(values?.email, friend, hash, true);
      toast.success(`✅Sent ${friend.amount}TRX to ${friend.address}`, {
        id: notification,
      });
    } catch (error) {}
  };

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(friend);
    sendTokens();
  };
  console.log(values);
  return (
    <div className="lg:px-12">
      <div>
        <p className="text-xl font-semibold py-2 title">Send Gifts</p>
      </div>
      <div className="lg:grid grid-cols-5 lg:space-x-3 mx-2">
        <div className="col-span-2 bg- my-4 h-[19rem] text-center py-3 rounded-sm shadow-lg bg-[#434242]">
          <div className="space-y-1">
            <p className="text-sm font-semibold text-white">
              Send tokens to friends and loved ones💜
            </p>
            <p className="text-xs text-white">Go ahead to send tokens</p>
          </div>
          <div>
            <form
              onSubmit={handleSubmit}
              className="text-start px-8 py-6 space-y-3"
            >
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4 text-white">
                  Reciever wallet
                </label>
                <input
                  id="address"
                  type="text"
                  className="py-2 w-full p-2 text-sm bg-white/60 rounded-md"
                  name="address"
                  placeholder="Wallet name eg(wallet#1)"
                  value={friend.address}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4 text-white">
                  Amount
                </label>
                <input
                  id="amount"
                  type="number"
                  className="py-2 w-full p-2 text-sm bg-white/60 rounded-md"
                  name="amount"
                  placeholder="Amount of tokens"
                  value={friend.amount}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="flex text-white bg-[#22f4fa]/60 justify-center items-center w-full cursor-pointer p-3 font-medium text-center rounded-sm text-sm"
                >
                  Send Tokens
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="col-span-3 bg-[#434242] rounded shadow-xl px-6 py-3 h-[80vh] overflow-y-scroll">
          <div className="py-2">
            <p className="text-center font-semibold text-lg text-white">
              Personal Transactions
            </p>
          </div>
          <>
            <div className=" overflow-y-scroll w-full">
              <div>
                {transactions.map((item, i) => (
                  <div
                    onClick={() => handleProceed(item?.transactionHash, item)}
                    key={i}
                  >
                    <PersonalTransactions transaction={item} />
                  </div>
                ))}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Payment;
